import { useFloating, autoUpdate, flip, shift } from "@floating-ui/react";

// Positions a portalled autocomplete menu under its input using
// @floating-ui/react. The return shape is kept identical to the previous
// react-popper implementation so consumers need no changes.
function usePopperPortal() {
  const { refs, floatingStyles, elements } = useFloating<HTMLDivElement>({
    placement: "bottom-start",
    strategy: "absolute",
    middleware: [flip(), shift()],
    whileElementsMounted: autoUpdate,
  });
  // Hvis autocomplete er i en modal, så skal den rendere i modalens container
  // ellers skal den rendere i body
  const popperPortalContainer =
    document.getElementsByClassName("c-modal-overlay")[0] ?? document.body;
  return {
    popperAttributes: {},
    popperPortalContainer,
    popperReferenceElement: elements.reference as HTMLElement | null,
    popperStyles: floatingStyles,
    setPopperElement: refs.setFloating,
    setPopperReferenceElement: refs.setReference,
  };
}

export default usePopperPortal;
